module.exports = __webpack_public_path__ + "img/pcad-materials.d276edef.png";